import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-sm-12 col-xl-12" }
const _hoisted_3 = { class: "text-success fw-bold" }
const _hoisted_4 = { class: "text-error fw-bold" }
const _hoisted_5 = { class: "text-primary fw-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_card, {
        flat: "",
        rounded: "lg",
        class: "performance-summary-card"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_data_table, {
            headers: $data.grid.headers,
            items: $data.platformRows,
            "items-per-page": 10,
            "item-value": "platform_id",
            class: "table text-start align-middle mb-0 custom-data-table"
          }, {
            [`item.profit_stock_count`]: _withCtx(({ item }) => [
              _createElementVNode("span", _hoisted_3, _toDisplayString(item.profit_stock_count), 1)
            ]),
            [`item.loss_stock_count`]: _withCtx(({ item }) => [
              _createElementVNode("span", _hoisted_4, _toDisplayString(item.loss_stock_count), 1)
            ]),
            [`item.free_stock_count`]: _withCtx(({ item }) => [
              _createElementVNode("span", _hoisted_5, _toDisplayString(item.free_stock_count), 1)
            ]),
            [`item.total_stock_count`]: _withCtx(({ item }) => [
              _createElementVNode("strong", null, _toDisplayString(item.total_stock_count), 1)
            ]),
            _: 2
          }, 1032, ["headers", "items"])
        ]),
        _: 1
      })
    ])
  ]))
}